function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_284",
  "data-name": "Group 284",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_132",
  "data-name": "Path 132",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_133",
  "data-name": "Path 133",
  d: "M20 7v14a1 1 0 01-1 1H5a1 1 0 01-1-1V7H2V5h20v2zM7 2h10v2H7z",
  fill: "#fff"
})));